(function () {
  const AUTOPLAY_DELAY = 5000;
  const DRAG_THRESHOLD = 30;
  const FILTER_HIDE_DELAY = 240;

  function initHeroSlider(hero) {
    const slides = Array.from(hero.querySelectorAll("[data-hoshiyo-hero-slide]"));
    const dots = Array.from(hero.querySelectorAll("[data-hoshiyo-hero-dot]"));
    const prev = hero.querySelector("[data-hoshiyo-hero-prev]");
    const next = hero.querySelector("[data-hoshiyo-hero-next]");
    const desktopThumbQuery = window.matchMedia("(min-width: 990px)");
    const thumbButtons = [];
    let thumbs = null;

    if (slides.length < 2) {
      return;
    }

    function buildThumbs() {
      if (thumbs) {
        return;
      }

      thumbs = document.createElement("div");
      thumbs.className = "hoshiyo-v3-hero__thumbs";
      thumbs.setAttribute("aria-label", "Hero banner thumbnails");

      slides.forEach((slide, slideIndex) => {
        const image = slide.querySelector("img");
        if (!image) {
          return;
        }

        const button = document.createElement("button");
        button.type = "button";
        button.className = "hoshiyo-v3-hero__thumb";
        button.setAttribute("aria-label", `Show banner ${slideIndex + 1}`);
        button.addEventListener("click", () => goTo(slideIndex));

        const thumbImage = image.cloneNode(false);
        thumbImage.removeAttribute("loading");
        thumbImage.removeAttribute("width");
        thumbImage.removeAttribute("height");
        thumbImage.alt = image.alt;

        button.appendChild(thumbImage);
        thumbs.appendChild(button);
        thumbButtons.push(button);
      });

      hero.appendChild(thumbs);
    }

    let index = Math.max(0, slides.findIndex((slide) => slide.classList.contains("is-active")));
    let timer = null;
    let startX = 0;
    let isDragging = false;
    let didDrag = false;

    function render() {
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle("is-active", slideIndex === index);
      });

      dots.forEach((dot, dotIndex) => {
        if (dotIndex === index) {
          dot.setAttribute("aria-current", "true");
        } else {
          dot.removeAttribute("aria-current");
        }
      });

      thumbButtons.forEach((thumbButton, thumbIndex) => {
        thumbButton.classList.toggle("is-active", thumbIndex === index);
        if (thumbIndex === index) {
          thumbButton.setAttribute("aria-current", "true");
        } else {
          thumbButton.removeAttribute("aria-current");
        }
      });
    }

    function goTo(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      render();
      restartAutoplay();
    }

    function restartAutoplay() {
      window.clearInterval(timer);
      timer = window.setInterval(() => {
        index = (index + 1) % slides.length;
        render();
      }, AUTOPLAY_DELAY);
    }

    prev?.addEventListener("click", () => goTo(index - 1));
    next?.addEventListener("click", () => goTo(index + 1));
    dots.forEach((dot, dotIndex) => dot.addEventListener("click", () => goTo(dotIndex)));
    buildThumbs();

    function syncThumbVisibility() {
      if (!thumbs) {
        return;
      }

      thumbs.hidden = !desktopThumbQuery.matches;
    }

    function onDragMove(event) {
      if (!isDragging) {
        return;
      }

      if (Math.abs(event.clientX - startX) >= DRAG_THRESHOLD) {
        didDrag = true;
      }
    }

    function onDragEnd(event) {
      if (!isDragging) {
        return;
      }

      const deltaX = event.clientX - startX;
      isDragging = false;
      hero.classList.remove("is-dragging");
      document.removeEventListener("mousemove", onDragMove);
      document.removeEventListener("mouseup", onDragEnd);

      if (Math.abs(deltaX) >= DRAG_THRESHOLD) {
        goTo(deltaX < 0 ? index + 1 : index - 1);
      }
    }

    function onDragCancel() {
      isDragging = false;
      didDrag = false;
      hero.classList.remove("is-dragging");
      document.removeEventListener("mousemove", onDragMove);
      document.removeEventListener("mouseup", onDragEnd);
    }

    hero.addEventListener("dragstart", (event) => {
      event.preventDefault();
    });

    hero.addEventListener("mousedown", (event) => {
      if (event.button !== 0) {
        return;
      }

      if (event.target.closest("a, button")) {
        return;
      }

      isDragging = true;
      didDrag = false;
      startX = event.clientX;
      hero.classList.add("is-dragging");
      event.preventDefault();
      document.addEventListener("mousemove", onDragMove);
      document.addEventListener("mouseup", onDragEnd);
      window.addEventListener("blur", onDragCancel, { once: true });
    });

    hero.addEventListener(
      "click",
      (event) => {
        if (!didDrag) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        didDrag = false;
      },
      true
    );

    hero.classList.add("is-js-ready");
    syncThumbVisibility();
    if (desktopThumbQuery.addEventListener) {
      desktopThumbQuery.addEventListener("change", syncThumbVisibility);
    } else if (desktopThumbQuery.addListener) {
      desktopThumbQuery.addListener(syncThumbVisibility);
    }
    render();
    restartAutoplay();
  }

  function init() {
    document.querySelectorAll("[data-hoshiyo-hero-slider]").forEach(initHeroSlider);
    document.querySelectorAll("[data-series-filter-bar]").forEach(initSeriesFilter);
  }

  function initSeriesFilter(filterBar) {
    const section = filterBar.closest(".hoshiyo-v3-duo");
    if (!section) {
      return;
    }

    const cards = Array.from(section.querySelectorAll("[data-series-card]"));
    const buttons = Array.from(filterBar.querySelectorAll("[data-series-filter]"));
    if (!cards.length || !buttons.length) {
      return;
    }

    let activeFilter = "all";
    const hideTimers = new WeakMap();

    function setButtonState(nextFilter) {
      buttons.forEach((button) => {
        const isActive = button.dataset.seriesFilter === nextFilter;
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-pressed", String(isActive));
      });
    }

    function showCard(card) {
      const timer = hideTimers.get(card);
      if (timer) {
        window.clearTimeout(timer);
        hideTimers.delete(card);
      }

      card.hidden = false;
      card.classList.remove("is-filter-hidden");
      requestAnimationFrame(() => {
        card.classList.add("is-filter-visible");
      });
    }

    function hideCard(card) {
      const timer = hideTimers.get(card);
      if (timer) {
        window.clearTimeout(timer);
      }

      card.classList.remove("is-filter-visible");
      card.classList.add("is-filter-hidden");
      const nextTimer = window.setTimeout(() => {
        card.hidden = true;
      }, FILTER_HIDE_DELAY);
      hideTimers.set(card, nextTimer);
    }

    function applyFilter(nextFilter) {
      activeFilter = nextFilter;
      setButtonState(nextFilter);

      cards.forEach((card) => {
        const cardFilter = (card.dataset.seriesCategory || "").toLowerCase();
        const shouldShow = nextFilter === "all" || cardFilter === nextFilter.toLowerCase();

        if (shouldShow) {
          showCard(card);
        } else {
          hideCard(card);
        }
      });
    }

    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        const nextFilter = button.dataset.seriesFilter || "all";
        if (nextFilter === activeFilter) {
          return;
        }

        applyFilter(nextFilter);
      });
    });

    applyFilter(activeFilter);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
